import { useEffect } from "react";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

type EditablePluginProps = {
    disabled?: boolean;
};

export function EditablePlugin({ disabled = false }: EditablePluginProps) {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        editor.setEditable(!disabled);
    }, [editor, disabled]);

    return null;
}
